import useAddressTab from '~/components/Contacts/UpsertContact/Tabs/Address';
import useAuTfnTab from '~/components/Contacts/UpsertContact/Tabs/AuTfn';
import useBusinessTab from '~/components/Contacts/UpsertContact/Tabs/Business';
import useCoiTab from '~/components/Contacts/UpsertContact/Tabs/COI';
import useCommunicationTab from '~/components/Contacts/UpsertContact/Tabs/Communication';
import useContractOfServiceTab from '~/components/Contacts/UpsertContact/Tabs/ContractOfService';
import useDetailsTab from '~/components/Contacts/UpsertContact/Tabs/Details';
import useFinanceTab from '~/components/Contacts/UpsertContact/Tabs/Finance';
import useIntegrationsTab from '~/components/Contacts/UpsertContact/Tabs/Integrations';
import useW9Tab from '~/components/Contacts/UpsertContact/Tabs/W9';
import type { Tab } from '~/components/Contacts/UpsertContact/types';

export const useContactTabs = (): { allTabs: Tab[]; filteredTabs: Tab[] } => {
  // Outside of Formik Context
  const DetailsTab = useDetailsTab();
  const AddressTab = useAddressTab();
  const CommunicationTab = useCommunicationTab();
  const W9Tab = useW9Tab();
  const AuTfnTab = useAuTfnTab();
  const CoiTab = useCoiTab();
  const ContractOfServiceTab = useContractOfServiceTab();
  const FinanceTab = useFinanceTab();
  const IntegrationsTab = useIntegrationsTab();
  const BusinessTab = useBusinessTab();

  const allTabs: Tab[] = [
    DetailsTab,
    AddressTab,
    CommunicationTab,
    W9Tab,
    AuTfnTab,
    CoiTab,
    ContractOfServiceTab,
    FinanceTab,
    IntegrationsTab,
    BusinessTab,
  ];

  const filteredTabs: Tab[] = allTabs.filter((tab) => !tab.isHiddenForContact || !tab.isHiddenForContact());

  return {
    allTabs,
    filteredTabs,
  };
};
